import { useEffect } from 'react';
import Navigation from '../../components/base/Navigation';
import Footer from '../../components/base/Footer';
import CookieBanner from '../../components/base/CookieBanner';
import WhatsAppButton from '../../components/base/WhatsAppButton';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'Política de Privacidad - Altta Talent Studio';
  }, []);

  return (
    <div className="min-h-screen bg-[#f7f3f0]">
      <Navigation />
      <main className="pt-20">
        <section className="py-20">
          <div className="container-custom section-padding">
            <div className="max-w-4xl mx-auto bg-white p-8 lg:p-12 rounded-sm shadow-lg">
              <h1 className="text-4xl museo-font text-[#3a3a3a] mb-8 font-medium">
                Política de Privacidad
              </h1>
              
              <div className="prose max-w-none text-[#3a3a3a]/90 leading-relaxed space-y-6">
                <h2 className="text-2xl museo-font text-[#3a3a3a] font-medium">
                  Información sobre Protección de Datos
                </h2>
                <p>
                  En cumplimiento del Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 
                  relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales 
                  (RGPD), le informamos sobre el tratamiento de sus datos personales.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Responsable del Tratamiento
                </h3>
                <p>
                  <strong>Denominación:</strong> Altta Talent Studio<br />
                  <strong>Dirección:</strong> Paseo de la Independencia 25, 50001 Zaragoza, España<br />
                  <strong>Email:</strong> contacto@alttatalentstudio.com<br />
                  <strong>Teléfono:</strong> +34 644 221 998
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Finalidad del Tratamiento
                </h3>
                <p>
                  Los datos personales que nos proporcione serán utilizados para las siguientes finalidades:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Gestionar y responder a sus consultas y solicitudes</li>
                  <li>Prestación de servicios de representación de talento</li>
                  <li>Comunicaciones comerciales y promocionales (con su consentimiento)</li>
                  <li>Cumplimiento de obligaciones legales</li>
                </ul>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Base Jurídica
                </h3>
                <p>
                  El tratamiento de sus datos se basa en:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>La ejecución de un contrato o medidas precontractuales</li>
                  <li>El cumplimiento de una obligación legal</li>
                  <li>Su consentimiento expreso para comunicaciones comerciales</li>
                  <li>El interés legítimo para la gestión de consultas</li>
                </ul>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Conservación de Datos
                </h3>
                <p>
                  Sus datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad 
                  para la que fueron recabados y para determinar las posibles responsabilidades que se pudieran 
                  derivar de dicha finalidad y del tratamiento de los datos.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Destinatarios
                </h3>
                <p>
                  Sus datos no serán cedidos a terceros, salvo obligación legal o cuando sea necesario 
                  para la prestación del servicio solicitado.
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Derechos del Interesado
                </h3>
                <p>
                  Tiene derecho a:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Acceder a sus datos personales</li>
                  <li>Rectificar los datos inexactos</li>
                  <li>Solicitar la supresión de los datos</li>
                  <li>Solicitar la limitación del tratamiento</li>
                  <li>Oponerse al tratamiento</li>
                  <li>Solicitar la portabilidad de los datos</li>
                </ul>

                <p>
                  Para ejercer estos derechos, puede contactar con nosotros en: contacto@alttatalentstudio.com
                </p>

                <h3 className="text-xl museo-font text-[#3a3a3a] font-medium">
                  Reclamaciones
                </h3>
                <p>
                  Si considera que el tratamiento no se ajusta a la normativa vigente, podrá presentar 
                  una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).
                </p>

                <p className="text-sm text-[#3a3a3a]/70 mt-8">
                  Última actualización: {new Date().toLocaleDateString('es-ES')}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <CookieBanner />
      <WhatsAppButton />
    </div>
  );
};

export default PrivacyPage;